import { useEffect, useState } from 'react';
import type { Locale } from 'date-fns';
import enUS from 'date-fns/locale/en-US';

const getProviderURL = (
  code: string,
  provider: 'jsdelivr' | 'skypack' = 'jsdelivr'
) => {
  return {
    jsdelivr: `https://cdn.jsdelivr.net/npm/date-fns@2/esm/locale/${code}/index.js/+esm`,
    skypack: `https://cdn.skypack.dev/date-fns@2/esm/locale/${code}/index.js`
  }[provider];
};

const mapLocaleCode = {
  en: 'en-US',
  'en-au': 'en-AU',
  'en-gb': 'en-GB',
  fa: 'fa-IR',
  iw: 'he',
  ky: 'ky', // this locale doesnt exist
  ml: 'ml', // this locale doesnt exist
  mr: 'mr', // this locale doesnt exist
  my: 'my', // this locale doesnt exist
  pa: 'pa', // this locale doesnt exist
  tl: 'tl', // this locale doesnt exist
  no: 'nb',
  pt: 'pt',
  'es-ar': 'es',
  'es-cl': 'es',
  'es-co': 'es',
  'es-mx': 'es',
  'pt-br': 'pt-BR',
  'pt-pt': 'pt',
  'zh-cn': 'zh-CN',
  'zh-tw': 'zh-TW'
};

const absentLocales = ['ky', 'ml', 'mr', 'my', 'pa', 'tl'];

export const useImportDateFnsLocale = (code: string) => {
  const [locale, setLocale] = useState<Locale>(enUS);

  useEffect(() => {
    const dateFnsCode =
      code in mapLocaleCode
        ? mapLocaleCode[code as keyof typeof mapLocaleCode]
        : code;

    const initLocale = async () => {
      if (dateFnsCode === 'en-US' || absentLocales.includes(dateFnsCode)) {
        return setLocale(enUS);
      }

      try {
        const importedLocaleModule = await import(
          /* @vite-ignore */ getProviderURL(dateFnsCode)
        );
        const importedLocale = importedLocaleModule.default;

        setLocale(importedLocale);
      } catch (e) {
        console.warn(e);
        setLocale(enUS);
      }
    };

    initLocale();
  }, [code]);

  return locale;
};
